import {
  resizeTopLeftCorner,
  resizeTopRigthCorner,
  resizeBottomLeftCorner,
  resizeBottomRightCorner,
} from './utils'

export function resize(
  absolutePoint,
  status,
  currentItemView,
  resizeOptions,
  area,
) {
  switch (status) {
    case 'top-left':
      //resize top left corner of current itemView
      resizeTopLeftCorner(currentItemView.boundary, resizeOptions, absolutePoint)

      //stop checking of interactions
      return true

    case 'top-right':
      //resize top right corner of current itemView
      resizeTopRigthCorner(currentItemView.boundary, resizeOptions, absolutePoint, area)

      //stop checking of interactions
      return true

    case 'bottom-left':
      //resize bottom left corner of current itemView
      resizeBottomLeftCorner(currentItemView.boundary, resizeOptions, absolutePoint, area)

      //stop checking of interactions
      return true

    case 'bottom-right':
      //resize bottom right corner of current itemView
      resizeBottomRightCorner(currentItemView.boundary, resizeOptions, absolutePoint, area)

      //stop checking of interactions
      return true
  }

  return false
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseMove/resize.js